import * as React from 'react';

import { MetricCardWithTimeSeries } from '@tableau/metrics-shared-widgets-dom/lib/src/MetricCardWithTimeSeries';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { ParsedMetricData } from '../../../metrics';
import { metricCardPropsFromSummary } from '../../../metrics/metricCardPropsFromSummary';
import { L10n } from '../../../ts/L10n/L10n';
import { isMetricInfo } from '../../../ts/models/IMetricInfo';
import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, ContentCardProps, getContentUrlForItem } from './ContentCard';

interface MetricCardState {
  parsedData?: ParsedMetricData;
}

export class MetricCard extends ContentCard<ContentCardProps, MetricCardState> {
  public state: MetricCardState = {};

  private renderTimerHandle?: ReturnType<typeof setTimeout>;

  public render() {
    const containerClass = this.props.hoveredOrSelected ? CardViewStyles.MetricCardHover
      : CardViewStyles.Card;
    return (
      <div className={containerClass}>
        <a href={getContentUrlForItem(this.props.content, this.props.urls)} style={{ textDecoration: 'none' }}>
          {this.renderMetricCard(this.props.content)}
        </a>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            {L10n.elideIfLong(this.props.content.name)}
          </span>
          <span>
            <FavoriteToggle canHaveKeyboardFocus={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite(this.props.content.id, 'metric')}
              onRemoveFavorite={() => this.props.removeContentFavorite(this.props.content.id, this.props.content.id, 'metric', this.props.content.name)} />
          </span>
        </div>
      </div>
    );
  }

  public componentDidUpdate(prevProps: Readonly<ContentCardProps>, prevState: Readonly<MetricCardState>): void {
    this.delayAddingDataToState(this.state, this.props.content);
  }

  public componentDidMount(): void {
    this.delayAddingDataToState(this.state, this.props.content);
  }

  public componentWillUnmount() {
    if (this.renderTimerHandle) {
      clearTimeout(this.renderTimerHandle);
    }
  }

  private delayAddingDataToState(state: MetricCardState, content: IExplorableItemTypeInfo): void {
    if (isMetricInfo(content) && state.parsedData !== content.parsedData) {
      this.renderTimerHandle = setTimeout(() => this.setState({parsedData: content.parsedData}),
        Math.floor(Math.random() * 10));
    }
  }

  private renderMetricCard(content: IExplorableItemTypeInfo) {
    if (isMetricInfo(content) && this.state.parsedData && this.state.parsedData.data) {
      return (
        <MetricCardWithTimeSeries {...metricCardPropsFromSummary(this.state.parsedData)} />
      );
    } else {
      return (
        <div className={CardViewStyles.MetricEmptyCard} />
      );
    }
  }
}
